import innerRadius from './innerRadius'

export default ({ day, isSmall }) => {
  if (isSmall) {
    return '80%'
  }

  return innerRadius({ day }) + 20
}
